<thead class="m-table-head"
       :class="[
            'm--is-head-style-' + headStyle,
            {
                'm--is-first-column-fixed': firstColumnFixed,
                'm--has-multiple-head-row': hasMultipleHeadRow,
            },
        ]">
    <tr v-for="(headRow, headRowKey) in headRows"
        :key="headRowKey"
        :class="headRow.className">
        <th v-for="(column, i) in headRow.columns"
            :key="i"
            :id="column.name + '-' + id"
            :colspan="column.colspan"
            :rowspan="column.rowspan"
            scope="col"
            :class="[
                {
                    'm--is-sortable': column.sortable,
                    'm--is-sorted': isColumnSorted(column),
                    'm--is-disabled': disabled,
                    'm--is-initial-sort': column.isInitialSort,
                },
                getColumnAlignmentClass(column),
                column.className,
            ]"
            :style="[
                getColumnWidthStyle(column),
                column.style
            ]">
            <slot v-if="!column.sortable"
                  :name="'head-cell.' + column.name"
                  :column="column">
                <slot name="head-cell"
                      :column="column">
                    <template v-if="column.value">
                        {{ column.value }}
                    </template>
                </slot>
            </slot>
            <div v-else
                 class="m-table-head__cell">
                <div class="m-table-head__cell-content"
                     @click="sort(column, headRow.columns)">
                    <slot :name="'head-cell.' + column.name"
                          :column="column">
                        <slot name="head-cell"
                              :column="column">
                            <template v-if="column.value">
                                {{ column.value }}
                            </template>
                        </slot>
                    </slot>
                    <m-icon-button class="m-table-head__sort-icon"
                                   :class="getColumnSortDirectionClass(column)"
                                   :skin="getSkinSortIcon(headRowKey)"
                                   :disabled="disabled"
                                   button-size="14px"
                                   icon-size="12px"
                                   :icon-name="getColumnSortIcon(column)"
                                   @click.stop="sort(column, headRow.columns)" />
                </div>
            </div>
        </th>
    </tr>
</thead>
